import styled from 'styled-components';

import { WHITE } from '../../../utils/colours';

import { hideSpinButtons } from '../helpers';
import { inputStyling } from '../helpers.new';

interface InputContainerProps {
    $hideSpinButtons?: boolean;
    $accentColour?: string;
    largeFontSize?: boolean;
    large?: boolean;
    fullWidth?: boolean;
    narrowWidth?: boolean;
    error?: boolean;
    variant?: 'light' | 'dark';
}

export const InputContainer = styled.input<InputContainerProps>`

    /* Styles apply to all input fields except checkbox and slider */
    :not([type='checkbox']):not([type='range']) {
        ${(props) => inputStyling(props)}

        &:read-only {
            border: none;
            opacity: 0.4;
        }

        ${({ $hideSpinButtons }) => ($hideSpinButtons ? hideSpinButtons : '')}
    }

    /* Checkbox styles. */
    &[type="checkbox"] {
        cursor: pointer;

        &:disabled {
            cursor: not-allowed;
        }
    }

    /* Slider styles. */
    &[type="range"] {
        width: 100%;
        background: none;
        height: 27px;
        -webkit-appearance: none;
        &::-webkit-slider-runnable-track {
            height: 2px;
            cursor: pointer;
            animate: 0.2s;
            background: ${WHITE()};
            border-radius: 4px;
            border: none;
        }
        &::-webkit-slider-thumb {
            box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
            border: none;
            height: 20px;
            width: 20px;
            border-radius: 20px;
            background: ${({ $accentColour }) => $accentColour};
            cursor: pointer;
            -webkit-appearance: none;
            margin-top: -9px;
        }
        &:focus::-webkit-slider-runnable-track {
            background: ${WHITE()};
        }

        &::-moz-range-track {
            height: 2px;
            cursor: pointer;
            animate: 0.2s;
            background: ${WHITE()};
            border-radius: 4px;
            border: 0px solid #010101;
        }
        &::-moz-range-thumb {
            box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
            border: 0px solid ${({ $accentColour }) => $accentColour};
            height: 20px;
            width: 20px;
            border-radius: 20px;
            background: ${({ $accentColour }) => $accentColour};
            cursor: pointer;
        }

        &::-ms-track {
            width: 100%;
            height: 2px;
            cursor: pointer;
            animate: 0.2s;
            background: transparent;
            border-color: transparent;
            color: transparent;
        }
        &::-ms-fill-lower {
            background: ${WHITE()};
            border: 0px solid #010101;
            border-radius: 8px;
        }
        &::-ms-fill-upper {
            background: ${WHITE()};
            border: 0px solid #010101;
            border-radius: 8px;
        }
        &::-ms-thumb {
            margin-top: 1px;
            box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
            border: 0px solid ${({ $accentColour }) => $accentColour};
            height: 20px;
            width: 20px;
            border-radius: 20px;
            background: ${({ $accentColour }) => $accentColour};
            cursor: pointer;
        }
        &:focus::-ms-fill-lower {
            background: ${WHITE()};
        }
        &:focus::-ms-fill-upper {
            background: ${WHITE()};
        }
    }
`;

InputContainer.displayName = 'InputContainer';

export default InputContainer;
